import { render, staticRenderFns } from "./private-policy.vue?vue&type=template&id=5b7a30e8&"
import script from "./private-policy.js?vue&type=script&lang=js&"
export * from "./private-policy.js?vue&type=script&lang=js&"
import style0 from "./private-policy.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports